import constants from '../constants';

export const setNamespace = namespace => ({
  type: constants.SET_NAMESPACE,
  payload: namespace,
});
